var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReasonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#0072CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 12.76V15.9C21.28 16.1 21.27 16.3 21.25 16.49C21.07 18.61 19.82 19.67 17.52 19.67H17.21C17.01 19.67 16.82 19.76 16.71 19.92L15.77 21.18C15.35 21.74 14.68 21.74 14.26 21.18L13.32 19.92C13.22 19.79 12.99 19.67 12.82 19.67H12.51C10 19.67 8.75 19.05 8.75 15.91V12.77C8.75 10.47 9.80999 9.22001 11.93 9.04001C12.12 9.02001 12.32 9.01001 12.52 9.01001H17.55C20.02 9.00001 21.28 10.26 21.28 12.76Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.1898 5H10.8198C7.17976 5 5.00977 7.17 5.00977 10.81V19.18C5.00977 22.82 7.17976 24.99 10.8198 24.99H19.1898C22.8298 24.99 24.9998 22.82 24.9998 19.18V10.81C24.9998 7.17 22.8298 5 19.1898 5Z",
    fill: "#F7F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonIcon);
export default __webpack_public_path__ + "static/media/reason_icon.08c2f5b247872f004a5e046191d96077.svg";
export { ForwardRef as ReactComponent };